// Confirm a leader release of an order a packer holds at a desk (Admin >
// Warehouse > Outbound "Packing now" and the Admin > Orders modal). One
// primary action; the packer's boxes and scans are kept either way.
import { X } from "lucide-react";
import { useTranslation } from "../../i18n";

type Props = {
    orderNumber: string;
    packerName: string;
    busy: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const ReleaseClaimModal = ({ orderNumber, packerName, busy, onConfirm, onCancel }: Props) => {
    const { t } = useTranslation();
    return (
        <div className="modal-overlay" onClick={() => !busy && onCancel()}>
            <div
                className="modal-card"
                role="dialog"
                aria-label={t("packing_now_release_title")}
                onClick={e => e.stopPropagation()}
            >
                <div className="modal-card-header">
                    <h2>{t("packing_now_release_title")}</h2>
                    <button className="modal-close" onClick={onCancel} disabled={busy} aria-label={t("close")}>
                        <X size={18} />
                    </button>
                </div>
                <div className="modal-card-body">
                    <p className="admin-settings-section-hint">
                        {t("packing_now_release_confirm", { order: orderNumber, name: packerName })}
                    </p>
                    <div className="modal-confirm-buttons" style={{ justifyContent: "center", marginTop: 16 }}>
                        <button type="button" className="btn btn-ghost dispatch-modal-btn" onClick={onCancel} disabled={busy}>
                            {t("cancel")}
                        </button>
                        <button type="button" className="btn btn-primary dispatch-modal-btn" onClick={onConfirm} disabled={busy}>
                            {t("packing_now_release")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReleaseClaimModal;
